import dayjs from 'dayjs'

import type {
  OfferPriceType,
  OfferUnavailableReason,
  PriceSource,
  PriceUnavailableReason,
  StockItemType,
} from '@/types'

export const PRICE_UNAVAILABLE_TEXT = 'Цену уточняйте'

export const OFFER_UNAVAILABLE_REASON_LABELS: Record<
  OfferUnavailableReason,
  string
> = {
  OWN_STOCK_IN_PROCUREMENT: 'Свой склад: в режиме закупки товар недоступен',
  OUT_OF_STOCK: 'Нет в наличии',
}

export const PRICE_UNAVAILABLE_REASON_LABELS: Record<
  PriceUnavailableReason,
  string
> = {
  SEGMENT_INACTIVE:
    'Сегмент клиента неактивен. Назначьте клиенту действующий сегмент',
  PARTNER_NO_PURCHASE_PRICE: 'Нет закупочной цены у партнёра: заказать нельзя',
  BELOW_PARTNER_COST:
    'Цена по сегменту ниже закупочной цены у партнёра: заказать нельзя',
  NO_PRICE: 'Нет цены по сегменту клиента',
  NO_FILE_PRICE: 'Нет цены из файла поставщика',
}

const PRICE_SOURCE_LABELS: Record<PriceSource, string> = {
  ERP: 'УТ',
  IMPORT_FILE: 'файл поставщика',
}

const UPDATED_AT_FORMAT = 'DD.MM.YYYY HH:mm'
const STOCK_UPDATED_AT_FORMAT = 'HH:mm DD.MM.YYYY'

type OfferStock = Pick<StockItemType, 'unavailableReason'>
type OfferPriceReason = Pick<OfferPriceType, 'unavailableReason'>

export const canAddOfferToCart = ({ unavailableReason }: OfferStock) =>
  unavailableReason === undefined

export const getOfferUnavailableText = ({ unavailableReason }: OfferStock) =>
  unavailableReason === undefined
    ? undefined
    : OFFER_UNAVAILABLE_REASON_LABELS[unavailableReason]

export const getPriceUnavailableText = (price: OfferPriceReason | undefined) =>
  price?.unavailableReason === undefined
    ? undefined
    : PRICE_UNAVAILABLE_REASON_LABELS[price.unavailableReason]

export const getOrderSelectionBlockText = (
  stock: Pick<StockItemType, 'unavailableReason' | 'quantity'> | undefined,
  price: Pick<OfferPriceType, 'sellingPrice' | 'unavailableReason'> | undefined
) => {
  if (!stock || stock.quantity <= 0) {
    return OFFER_UNAVAILABLE_REASON_LABELS.OUT_OF_STOCK
  }
  const stockText = getOfferUnavailableText(stock)
  if (stockText !== undefined) return stockText
  if (price?.sellingPrice !== undefined) return undefined
  return (
    getPriceUnavailableText(price) ?? PRICE_UNAVAILABLE_REASON_LABELS.NO_PRICE
  )
}

export const getUpdatedAtTitle = (
  kind: 'price' | 'stock',
  value: string | null | undefined
) => {
  if (value === undefined || value === null) return undefined
  return kind === 'price'
    ? `Обновлена ${dayjs(value).format(UPDATED_AT_FORMAT)}`
    : `Остаток на ${dayjs(value).format(STOCK_UPDATED_AT_FORMAT)}`
}

export const getPriceSourceText = (source: PriceSource | undefined) =>
  source === undefined ? undefined : `Источник: ${PRICE_SOURCE_LABELS[source]}`
